import React from "react";
import { empiTheme } from "./styles/empiTheme";

export default function Footer() {
  return (
    <footer style={footer}>
      <div style={container}>
        <div style={brand}>EmPi © {new Date().getFullYear()}</div>

        <div style={meta}>Human-Centered AI for Everyday Regulation</div>

        <div style={links}>
          <a href="/privacy" style={link}>
            Privacy Notice
          </a>

          <span style={dot}>•</span>

          <a href="mailto:hello@em-pi.ai" style={link}>
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}

const footer = {
  padding: "40px 0",
  background: empiTheme.colors.background,
  borderTop: `1px solid ${empiTheme.colors.border}`,
};

const container = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
  padding: "0 20px",
  display: "grid",
  gap: 10,
};

const brand = {
  fontWeight: 700,
  color: empiTheme.colors.text,
};

const meta = {
  fontSize: 14,
  color: empiTheme.colors.textSecondary,
};

const links = {
  display: "flex",
  gap: 10,
  alignItems: "center",
};

const link = {
  color: empiTheme.colors.text,
  textDecoration: "none",
  fontSize: 14,
};

const dot = {
  color: empiTheme.colors.textSecondary,
};
